import React from 'react';

import Accordion from '~components/Accordion';

import RoreUnallocatedList from './RoreUnallocatedList';

const RoreSideBar: React.FC = () => {
  const items = [
    {
      header: 'Unallocated Appointments',
      bodyComponent: RoreUnallocatedList,
      bodyProps: {},
    },
  ];

  return <Accordion className="side-bar-container" items={items} />;
};

export default RoreSideBar;
